module.exports = __webpack_public_path__ + "static/panorama-struga-db94e51aa853a6db8b7ff0f862f6c785.png";